import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BButton, BCard, BFormGroup, BFormInput, BFormRadio, BFormRadioGroup } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/remoteFiles";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import { fileSourcePluginToItem } from "../FilesDialog/utilities";
import ExternalLink from "@/components/ExternalLink.vue";
import FilesInput from "@/components/FilesDialog/FilesInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RDMDestinationSelector',
    props: {
        what: { default: "archive" },
        fileSource: { default: undefined }
    },
    emits: ["onRecordSelected"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const includeOnlyRDMCompatible = { include: ["rdm"] };
        const recordUri = ref("");
        const sourceUri = ref(props.fileSource?.uri_root ?? "");
        const exportChoice = ref("new");
        const recordName = ref("");
        const newEntry = ref();
        const canCreateRecord = computed(() => Boolean(sourceUri.value) && Boolean(recordName.value));
        const errorCreatingRecord = ref();
        const repositoryRecordDescription = computed(() => localize(`Select a repository to export ${props.what} to.`));
        const recordNameDescription = computed(() => localize("Give the new record a name or title."));
        const recordNamePlaceholder = computed(() => localize("Record name"));
        const uniqueSourceId = computed(() => props.fileSource?.id ?? "any");
        const fileSourceAsItem = computed(() => (props.fileSource ? fileSourcePluginToItem(props.fileSource) : undefined));
        watch(() => recordUri.value, (value) => {
            emit("onRecordSelected", value);
        });
        async function onCreateRecord() {
            try {
                await createRecord();
            }
            catch (error) {
                errorCreatingRecord.value = errorMessageAsString(error);
            }
        }
        async function createRecord() {
            const { data, error } = await GalaxyApi().POST("/api/remote_files", {
                body: {
                    target: sourceUri.value,
                    name: recordName.value,
                },
            });
            if (error) {
                errorCreatingRecord.value = errorMessageAsString(error);
                return;
            }
            newEntry.value = data;
            recordUri.value = newEntry.value.uri;
        }
        function reset() {
            recordUri.value = "";
            recordName.value = "";
            newEntry.value = undefined;
            exportChoice.value = "new";
        }
        expose({
            reset,
        });
        return { __sfc: true, props, emit, includeOnlyRDMCompatible, recordUri, sourceUri, exportChoice, recordName, newEntry, canCreateRecord, errorCreatingRecord, repositoryRecordDescription, recordNameDescription, recordNamePlaceholder, uniqueSourceId, fileSourceAsItem, onCreateRecord, createRecord, reset, BAlert, BButton, BCard, BFormGroup, BFormInput, BFormRadio, BFormRadioGroup, ExternalLink, FilesInput };
    }
});
